// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","modalShop":"Modal_modalShop__0S4Zt","modalHeader":"Modal_modalHeader__eJ-ri","closeBtn":"Modal_closeBtn__-YU4n"};